import { IEmployeeFilterState } from './EmployeeFilter.types';

export enum ActionTypes {
    SET_EMPLOYEEFILTERSELECTEDITEM = 'SET_EMPLOYEEFILTERSELECTEDITEM'
}

export type IEmployeeFilterActions = ISetEmployeeFilterSelectedItemAction;

export interface ISetEmployeeFilterSelectedItemAction {
    type: ActionTypes.SET_EMPLOYEEFILTERSELECTEDITEM;
    data: IEmployeeFilterState;
}
